import gen7Symbol from "../../assets/gen7Symbol.png";

// Explicit aliases only: never infer a brand from a fuzzy substring or Is Ours.
const brandFiles: Record<string, string> = {
  shell: "shell.png", esso: "esso.png", "canex esso": "esso.png", mobil: "mobil.svg",
  "petro-canada": "petro-canada.svg", canco: "canco.png",
  "canco supermarket": "canco.png", "canco gas & mellors supermarke": "canco.png",
  "wolves den gas bar by canco": "canco.png", "co-op": "co-op.png",
  "canadian tire": "canadian-tire.png", "circle k": "circle-k.svg",
  chevron: "chevron.svg", pioneer: "pioneer.svg", ultramar: "ultramar.svg",
  "fas gas": "fas-gas.svg", "fas gas plus": "fas-gas.svg",
  costco: "costco.png", "super save gas": "super-save.png"
};

export function gasBrandLogo(name: string): string | undefined {
  const normalized = name.trim().toLowerCase().replace(/\s+/g, " ");
  if (normalized === "gen7" || normalized === "gen 7 fuel") return gen7Symbol;
  const file = brandFiles[normalized];
  return file ? `/brands/${file}` : undefined;
}

export function createGasBrandIcon(name: string): HTMLElement {
  const container = document.createElement("span");
  container.className = "gas-brand-icon";
  container.setAttribute("aria-hidden", "true");
  const fallback = () => { container.textContent = "⛽"; container.classList.add("gas-brand-icon--generic"); };
  const logo = gasBrandLogo(name);
  if (!logo) { fallback(); return container; }
  const image = document.createElement("img");
  image.alt = "";
  image.width = 28; image.height = 28;
  image.addEventListener("error", fallback, { once: true });
  image.src = logo;
  container.append(image);
  return container;
}
